import { ref } from 'vue';

import { alerts, createAlert } from '../alerts.ts';

export function authenticationErrorMessage(reason: unknown) {
    if (reason instanceof Error) {
        return reason.message;
    }

    return 'Unable to continue. Please try again.';
}

export function useAuthenticationAction() {
    const busy = ref(false);

    async function run(
        action: () => Promise<void>,
        onError?: (reason: unknown) => boolean | undefined,
    ) {
        busy.value = true;

        try {
            await action();
        } catch (reason) {
            if (onError?.(reason) !== true) {
                alerts.show(
                    createAlert({ type: 'danger', message: authenticationErrorMessage(reason) }),
                );
            }
        } finally {
            busy.value = false;
        }
    }

    return { busy, run };
}
